<template>
    <div class="about">
        <!--        <h1>О проекте</h1>-->
        <!--        <p>Дорогой, читатель!</p>-->
        <!--        <p>Предлагаю вам новый и уникальный <strong>проект, призванный привить ребенку любовь к чтению через привычные-->
        <!--            ему-->
        <!--            средства коммуникации</strong>.</p>-->
        <!--        <p>Дети разные. И новое поколение уже не так охотно обра­щается к книгам, так как чтение требует довольно-->
        <!--            больших затрат энергии и времени. Обычная бумажная книга привлекает школьника все меньше, все больше он-->
        <!--            предпочитает читать “легкие” тексты с экрана электронного устройства. Как увлечь ребенка чтением серьезной-->
        <!--            классической литературы? Скольжение по тексту и клиповость мышления у школьников уже стали бичом-->
        <!--            современного образования. Как же развиваться современному школьнику без глубокого чтения серьезной-->
        <!--            литературы, когда это является основным методом не только получения информации, но и познания мира?!</p>-->
        <!--        <p>В ответ на этот вопрос два года назад и родилась идея этого проекта. Я заметил, что дети все чаще наотрез-->
        <!--            отказываются читать литературу, но, когда у ребенка появляется собственный смартфон, он активно пользуется-->
        <!--            мессенджерами, чатами и прочими программами для передачи текстовой информации. Возможно, <strong>современному-->
        <!--                ребенку нужна новая форма подачи материала</strong>.</p>-->
        <!--        <p>Почему форматом представления текста мною выбран именно чат и почему в этот формат вложены именно пьесы?-->
        <!--            Ответ прост: драматургический канон и форма интернет-переписки имеют схожие основы, и это — диалогичность-->
        <!--            формы. Реплики персонажей органично легли в привычную для каждого <strong>форму интернет-чата</strong>.-->
        <!--            Динамика появления-->
        <!--            персонажей на сцене также подобна присоединению и выходу новых пользователей в групповых чатах.</p>-->
        <!--        <p>После оформления с дизайнерами первого действия пьесы Николая Васильевича Гоголя “Ревизор” в форме чата,-->
        <!--            стало очевидно, что такая подача информации весьма эффективна. Однако любая идея требует проверки. В-->
        <!--            качестве фокус-группы было выбрано 30 человек, которым было предложено оценить чтение пьесы в таком формате.-->
        <!--            Они отмечали удобство восприятия, легкость переходов между репликами, особую визуальную гармонию текста.-->
        <!--            Поэтому я решил издать книгу-чат в печатном виде, а затем разработать специализированную электронную-->
        <!--            площадку в виде сервера, на котором можно будет не только читать, но и обсуждать литературные произведения,-->
        <!--            проходить тесты, участвовать в квестах и конкурсах, играть и общаться с персонажами классических-->
        <!--            произведений, а также делиться всеми достижениями в социальных сетях. Поразмыслить над текстом пьесы-->
        <!--            предлагается уже и в этом печатном издании: специально для этого я разработал в приложении <strong>ряд-->
        <!--                эвристических-->
        <!--                заданий по тексту</strong> “Ревизора”, заданий на внимательность и сообразительность, которые-->
        <!--            обязательно понравятся-->
        <!--            юным читателям.</p>-->
        <!--        <p>Я прекрасно понимаю роль классической литературы в развитии человека, становлении его как личности и именно-->
        <!--            поэтому решил начать издавать серию с такой замечательной пьесы, как “Ревизор”. Это мой <strong>издательский-->
        <!--                трибьют-->
        <!--                Николаю Васильевичу Гоголю</strong>.</p>-->
        <!--        <p>Серия “КНИГА-ЧАТ” будет состоять из известных произведений классической русской и зарубежной литературы и-->
        <!--            будет издаваться на нескольких языках.</p>-->
        <!--        <p>Желаю вам приятного чтения. Свои отзывы, предложения и мнения можете высказывать по адресу-->
        <!--            bookaas232@gmail.com и-->
        <!--            в социальных сетях и инстаграме.</p>-->
        <!--        <p>#книгачат #классикатоп #теперьнескучно #удобночитать #чтениепоновому</p>-->

        <!--        <p style="text-align: right; font-style: italic">Создатель серии “КНИГА-ЧАТ”</p>-->
        <!--        <p style="text-align: right; font-style: italic">Константин Страусов</p>-->
        <v-container fluid>
            <v-row>
                <v-col>
                    <v-textarea label="html" v-model="html"></v-textarea>
                </v-col>
                <v-col cols="1">
                    <v-btn color="success" block @click="run">=></v-btn>
                </v-col>
                <v-col>
                    <v-textarea label="jsx" v-model="result"></v-textarea>
                </v-col>
            </v-row>
        </v-container>
        <div id="mount"></div>
    </div>
</template>

<script>
    import htmlText from '../assets/1';
    import images from '../assets/images';

    export default {
        name: "About",
        data: () => ({
            html: '',
            result: '',
        }),
        mounted() {
            this.html = htmlText;
            console.log(htmlText);
            let c = document.createElement('div');
            c.innerHTML = htmlText;
            document.getElementById('mount').appendChild(c);
        },
        methods: {
            run() {
                let s = ``;
                console.log('run');
                let doc = [...document.querySelectorAll('#_idContainer000 > p, #_idContainer000 > h2')];
                for (let i in doc) {
                    console.log(i, doc[i]);
                    let image, author;
                    if (doc[i].classList.contains('bodyText')) {
                        image = images[doc[i].classList[1]];
                        if (!image) image = 0;
                        console.log(doc[i].classList, image);
                        author = doc[i].innerHTML.search(/<span class="bold">(.*?)<\/span>/i)!=-1 ? doc[i].innerHTML.match(/<span class="bold">(.*?)<\/span>/i)[1] : '###';
                        let newText = `
                            <View style={styles.block}>
                                <View style={styles.imageAvatarView}>
                                    <Image source={require('../assets/images/persons/` + image + `.jpg')} style={styles.image} />
                                </View>
                                <View style={{ flex: 1 }}>
                                    <TextAuthor author={'` + author + `'} />
                                    <Text style={styles.text}>
                        `;

                        doc[i].innerHTML = doc[i].innerHTML.replace(/<span class="bold">(.*?)<\/span>/i, '')
                        doc[i].innerHTML = doc[i].innerHTML.replace(/<span class="hidden">(.*?)<\/span>/i, '')
                        newText += doc[i].innerHTML.replaceAll(/<span class="italic">(.*?)<\/span>/ig, `<TextItalic text={'$1'} />`)
                            .replaceAll(/<span.*?<\/span>/ig, '');
                        // newText = newText.replaceAll('&nbsp;', `{'\u00A0'}`)
                        // newText = newText.replaceAll('&nbsp;', ' ')
                        s += newText + `
                                    </Text>
                                </View>
                            </View>

                        `

                    }
                    if (doc[i].classList.contains('actionPlaceDescription')) {
                        let newText = `

                        `;

                        doc[i].innerHTML = doc[i].innerHTML.replace(/<span class="bold">(.*?)<\/span>/i, '')
                        doc[i].innerHTML = doc[i].innerHTML.replace(/<span class="hidden">(.*?)<\/span>/i, '')
                        newText += doc[i].innerHTML.replaceAll(/<span class="italic">(.*?)<\/span>/ig, `<TextItalic text={'$1'} />`)
                            .replaceAll(/<span.*?<\/span>/ig, '');
                        // newText = newText.replaceAll('&nbsp;', `{'\u00A0'}`)
                        // newText = newText.replaceAll('&nbsp;', ' ')
                        s += newText + `
                                    </Text>
                                </View>
                            </View>

                        `

                    }

                    // let ch = doc[i].children;
                    console.log(author);
                }
                this.result = s;

            }
        }
    }
</script>

<style scoped>

</style>
